window.MIX_GOOGLE_KEY = process.env.MIX_GOOGLE_KEY;
require('./bootstrap');
import 'jquery-ui-dist/jquery-ui';

import Vue from 'vue';
import Echo from 'laravel-echo';
import VueEcho from 'vue-echo-laravel';
window.Pusher = require('pusher-js');

import {BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import CKEditor from 'ckeditor4-vue';
import vSelect from 'vue-select'
//import x5GMaps from 'x5-gmaps';
import * as moment from 'moment';
import * as VeeValidate from "vee-validate";
//import VueConfirmDialog from 'vue-confirm-dialog'
import VueConfirmDialog from './libs/vue-confirm-dialog';
import VueLazyLoad from 'vue-lazyload'
//import flatPickr from './libs/flatpickr';
import flatPickr from 'vue-flatpickr-component';
//import 'flatpickr/dist/flatpickr.css';
// try more themes at - https://flatpickr.js.org/themes/
//import 'flatpickr/dist/themes/material_blue.css';

//import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'jquery-ui-dist/jquery-ui.css';
import {library} from '@fortawesome/fontawesome-svg-core'
import {fas} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import 'vue-select/dist/vue-select.css';
import VueColumnsResizable from 'vue-columns-resizable';
require('vue-image-lightbox/dist/vue-image-lightbox.min.css');
require('vue-it-bigger/dist/vue-it-bigger.min.css')

library.add(fas)

import {dom} from '@fortawesome/fontawesome-svg-core'

dom.watch()

Vue.component('font-awesome-icon', FontAwesomeIcon)

import VueApexCharts from 'vue-apexcharts'
//console.log('MIX_GOOGLE_KEY',process.env.MIX_GOOGLE_KEY)
//Vue.use(x5GMaps, { key: process.env.MIX_GOOGLE_KEY, libraries: ['places'] });
Vue.use(DateRangePicker)
Vue.use(VeeValidate);
Vue.use(VueConfirmDialog);
Vue.use(VueLazyLoad);
Vue.use(VueColumnsResizable);

Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);
//Vue.component('flatPickr', flatPickr);
Vue.use(flatPickr);

Vue.component('DateRangePicker', DateRangePicker);
Vue.component('v-select', vSelect)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)

let truncate2 = function(text, length, clamp){
    clamp = clamp || '...';
    let node = document.createElement('div');
    node.innerHTML = text;
    let content = node.textContent;
    return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter('truncate2', truncate2);

Vue.filter('truncate', function (value, size, clamp) {
    clamp = clamp || '...';
    if (!value) return '';
    value = value.toString();

    if (value.length <= size) {
        return value;
    }
    return value.substr(0, size) + clamp;
});

// echo setup
const token = store.state.userState.token ? store.state.userState.token : null;

//console.log('pusher', process.env.MIX_PUSHER_APP_KEY, process.env.MIX_PUSHER_APP_CLUSTER, window.location.hostname)
//window.io = require('socket.io-client');
let EchoInstance = new Echo({
    authEndpoint: route('broadcast.auth'),
    broadcaster: "pusher",
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    forceTLS: process.env.MIX_PUSHER_FORCE_TLS ? process.env.MIX_PUSHER_FORCE_TLS : false,
    encrypted: process.env.MIX_PUSHER_ENCRYPTED ? process.env.MIX_PUSHER_ENCRYPTED : false,
    wsHost: window.location.hostname,
    wsPort: process.env.MIX_WS_PORT ? process.env.MIX_WS_PORT : 6001,
    wssHost: window.location.hostname,
    enabledTransports: ['ws', 'wss'],
    disabledTransports: ['sockjs', 'xhr_polling', 'xhr_streaming'], // Can be removed
    wssPort: process.env.MIX_WSS_PORT ? process.env.MIX_WSS_PORT : 6001,
    //broadcaster: 'socket.io',
    //host: window.location.hostname + ":6001",
    auth: {
        headers: {
            Authorization: "Bearer " + token
        }
    }
});
window.Echo = EchoInstance;
Vue.use(VueEcho, EchoInstance);

//Main pages
import App from './App.vue';
import router from './router';
import store from './store';

import axios from "axios";

// console.log('token', store.state.userState.token);
// Add a request interceptor
axios.interceptors.request.use(
    config => {
        const token = store.state.userState.token ? store.state.userState.token : null;
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
        }
        config.headers['Content-Type'] = 'application/json';
        return config;
    },
    error => {
        Promise.reject(error)
    });


//Add a response interceptor

axios.interceptors.response.use((response) => {
    if (response.status === 401) {
        // console.log("INSIDE = 401", response);
        store.state.userState.auth = null;
        store.state.userState.token = null;
        store.state.userState.tokenType = null;
        store.state.userState.expiresIn = null;
        store.state.userState.role_name = null;
        store.state.userState.permissions = [];
        localStorage.removeItem('auth');
        localStorage.removeItem("token");
        router.push({ name: 'login' });
    }

    return response
}, function (error) {
    const originalRequest = error.config;


    if (error.response.status === 500) {
        console.log("INSIDE = 500", error);
        //store.state.userState.auth = null;
        //store.state.userState.token = null;
        //store.state.userState.tokenType = null;
        //store.state.userState.expiresIn = null;
        //localStorage.removeItem('auth');
        //router.push({ name: 'login' });
        return Promise.reject(error);
    }

    if (error.response.status === 401) {
        console.log("INSIDE = 401", error);
        store.state.userState.auth = null;
        store.state.userState.token = null;
        store.state.userState.tokenType = null;
        store.state.userState.expiresIn = null;
        store.state.userState.role_name = null;
        store.state.userState.permissions = [];
        localStorage.removeItem('auth');
        localStorage.removeItem("token");
        router.push({ name: 'login' });
        return Promise.reject(error);
    }


    if (error.response.status === 401 && originalRequest.url === window.route('refresh')) {
        console.log("INSIDE refresh= 401", error);
        store.state.userState.auth = null;
        store.state.userState.token = null;
        store.state.userState.tokenType = null;
        store.state.userState.expiresIn = null;
        store.state.userState.role_name = null;
        store.state.userState.permissions = [];
        localStorage.removeItem('auth');
        localStorage.removeItem("token");

        router.push({ name: 'login' });
        return Promise.reject(error);
    } else if (error.response.status === 401 && !originalRequest._retry) {
        console.log("INSIDE _retry= 401", error);
        originalRequest._retry = true;
        return axios.post(window.route('refresh'))
            .then(res => {
                if (res.status === 201) {
                    localStorage.setItem('auth', JSON.stringify(res.data.data));
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + res.data.data.access_token;
                    return axios(originalRequest);
                }
            })
    } else if (error.response.status === 401) {
        console.log("INSIDE = 401", error);
        store.state.userState.auth = null;
        store.state.userState.token = null;
        store.state.userState.tokenType = null;
        store.state.userState.expiresIn = null;
        store.state.userState.role_name = null;
        store.state.userState.permissions = [];
        localStorage.removeItem('auth');
        localStorage.removeItem("token");
        router.push({ name: 'login' });
        return Promise.reject(error);
    }
    return Promise.reject(error);
});


Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(CKEditor);


Vue.config.productionTip = false;
Vue.mixin({
    methods: {
        route,
        asset(path) {
            let base_path = window._asset || '';
            return base_path + path;
        },
        formatDate(date) {
            // return moment(date).format("DD/MM/YYYY");
            return moment(date).format("MM/DD/YYYY");
        },
        formatDateTime(date) {
            // return moment(date).format("DD/MM/YYYY");
            return moment(date).format(' h:mma, MMM DD YYYY');
        },
        nlToBr (str) {
            if(str != null)
                return str.replace(/\n/g, '<br>');
            return str;
        },
        ucfirst (str) {
            str += ''
            const f = str.charAt(0)
                .toUpperCase()
            return f + str.substr(1)
        },
        compareString (str1, str2) {
            if(str1 === null && str2 === null) {
                return true;
            } else if(str1 !== null && str2 === null) {
                return false;
            } else if(str1 === null && str2 !== null) {
                return false;
            }
            return str1 !== null && str2 !== null && str1.trim().toLowerCase() === str2.trim().toLowerCase();
        },
        checkDecimal(event, el) {
            //console.log('event', event.which);
            if ((event.which >= 48 && event.which <= 57) ||
                event.which == 8 ||
                event.which == 9 ||
                event.which == 37 ||
                event.which == 39 ||
                event.which == 46 ||
                event.which == 110 ||
                event.which == 127 ||
                event.which == 190 ||
                (event.which >= 96 && event.which <= 105)) {

            } else {
                event.preventDefault();
            }/*
            if (event.which != 46 && event.which != 8 && event.which != 110 &&
                event.which != 190 && (event.which < 48 || event.which > 57)) {
                event.preventDefault();
            }*/
        },
        checkNumber(event) {
            // console.log('event', event.which);
            if ((event.which >= 48 && event.which <= 57) ||
                event.which == 8 ||
                event.which == 9 ||
                event.which == 37 ||
                event.which == 39 ||
                event.which == 46 ||
                event.which == 127 ||
                (event.which >= 96 && event.which <= 105)) {

            } else {
                event.preventDefault();
            }/*if ((event.which < 48 || event.which > 57) && event.which != 8) {
                event.preventDefault();
            }*/
        },
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        isEven(n) {
            return n % 2 == 0;
        },
        isOdd(n) {
            return Math.abs(n % 2) == 1;
        },
        strAmountToNumber(str) {
            return _.isString(str) ? str.replace(",", "").replace("$", "") : str;
        },
        nameToCSSClass(name, prefix = '') {
            if(name) {
                return prefix + name.toLowerCase().replace(/\s+/g, '-').replace("/", "-").toLowerCase();
            }
            return "";
        },
        hasPerm(perm) {
            return store.state.userState.permissions && store.state.userState.permissions.length > 0 && store.state.userState.permissions.includes(perm);
        },
        hasRole(role) {
            return role == store.state.userState.role_name;
        },
        getUser(){
            return store.state.userState.auth;
        },
        getQuillToolbar() {
            return [
                [{
                    'font': []
                }, {
                    'size': []
                }],
                ['bold', 'italic', 'underline', 'strike'],
                [{
                    'color': []
                }, {
                    'background': []
                }],
                [{
                    'script': 'super'
                }, {
                    'script': 'sub'
                }],
                [{
                    'header': [false, 1, 2, 3, 4, 5, 6]
                }, 'blockquote', 'code-block'],
                [{
                    'list': 'ordered'
                }, {
                    'list': 'bullet'
                }, {
                    'indent': '-1'
                }, {
                    'indent': '+1'
                }],
                ['direction', {
                    'align': []
                }],
                ['link', 'image', 'video'],
                ['clean']
            ]
        },
        getMinQuillToolbar() {
            return [
                [
                    {
                        'size': []
                    },
                    'bold',
                    {
                        'color': []
                    },
                    {
                        'background': []
                    },
                    {
                        'list': 'ordered'
                    },
                    {
                        'list': 'bullet'
                    }
                ]
            ];
        },
        getXSmallQuillToolbar() {
            return [
                [
                    {
                        'font': []
                    },
                    {
                        'size': []
                    },
                    'bold', 'italic', 'underline',
                ]
            ];
        },
        ckEditorMinConfig() {
            return {
                toolbar: []
            };
        },
        createPOFromSO(order, originalOrderQuotes, setNewPurchaseOrder) {
            let newOrder = {
                order_id: null,
                vendor_id: null,
                vendor_company_name: null,
                is_draft: 0,
                po_number: null,
                order_date: null,
                vendor_terms: null,
                vendor_po: null,
                vendor_fob: null,
                eta: null,
                delivery_date: null,
                notes: null,
                po_status_id: 1,
                products: [],
                selectedProducts: [],
                quote_num: null
            };
            newOrder.order_id = order.id;
            newOrder.vendor_po = order.customer_po;

            let orderQuotes = originalOrderQuotes.filter((x) => x.quotation_products && x.quotation_products
                .filter((qp) => qp.quotation_prices && qp.quotation_prices.filter((qpp) => qpp.vendor_id).length).length > 0);

            if (orderQuotes.length) {
                newOrder.quote_num = orderQuotes[0].quotation_number;
                let quotation_products = orderQuotes[0].quotation_products.filter((qp) => qp.quotation_prices && qp.quotation_prices.filter((qpp) => qpp.vendor_id).length);
                if (quotation_products.length) {
                    let quotation_prices = quotation_products[0].quotation_prices.filter((qpp) => qpp.vendor_id);
                    if (quotation_prices.length) {
                        newOrder.vendor_id = quotation_prices[0].vendor_id;
                        newOrder.vendor_company_name = quotation_prices[0].vendor.company_name;
                        newOrder.vendor = quotation_prices[0].vendor;
                        newOrder.vendor_terms = quotation_prices[0].vendor.vendor_terms;
                    }
                }
            }

            setNewPurchaseOrder(newOrder);
            this.$router.push({name: 'purchaseSelectProducts', query: {order_id: order.id}});
        }
    }
});

const app = new Vue({
    router,
    store,
    render: createElement => createElement(App)
}).$mount('#app');

